import { gql, graphQueryBang } from "shared/lib/graphql"
import { actionQueryFields } from "../static_applet_composer/reducers/actions"
import { triggerQueryFields } from "../static_applet_composer/reducers/triggers"
import { queryQueryFields } from "../static_applet_composer/reducers/queries"
import formatStoredField from "shared/lib/format_stored_field"

const AvailableTandasQuery = gql`
  query($serviceModuleNames: [String]) {
    channels(module_names: $serviceModuleNames) {
      id
      name
      module_name
      lrg_monochrome_image_url
      lrg_variant_image_url
      brand_color
      triggers {
        ${triggerQueryFields}
      }
      actions {
        ${actionQueryFields}
      }
      queries {
        ${queryQueryFields}
      }
    }
  }
`

// availableTandasShape:
// {
//   google_calendar: {
//     actions: (2) [{…}, {…}]
//     brand_color: "2C6EFC"
//     id: "1396293310"
//     lrg_monochrome_image_url: "https://assets.ifttt.com/images/channels/1396293310/icons/monochrome_large.png"
//     lrg_variant_image_url: "https://assets.ifttt.com/images/channels/1396293310/icons/on_color_large.png"
//     module_name: "google_calendar"
//     name: "Google Calendar"
//     queries: (2) [{…}, {…}]
//     triggers: [{
//       can_have_default: false
//       field_type: "COLLECTION_SELECT"
//       helper_text: ""
//       hideable: false
//       id: "567369650"
//       label: "Which calendar?"
//       name: "calendar"
//       normalized_field_type: "option"
//       required: true
//       shareable: false
//       stored_field: {
//         can_have_default: false
//         field_subtype: "collection_select"
//         helper_text: ""
//         hideable: false
//         id: "/triggers/google_calendar.new_event_added@calendar"
//         label: "Which calendar?"
//         name: "calendar"
//         owner: "/triggers/google_calendar.new_event_added"
//         required: true
//         resolve_options: "/stored_fields/triggers/google_calendar.new_event_added/calendar/options"
//         shareable: false
//         type: "stored_field"
//       }
//     }, {...}]
//   }
//   twitch: {
//     actions: []
//     brand_color: "6441A5"
//     id: "603756155"
//     lrg_monochrome_image_url: "https://assets.ifttt.com/images/channels/603756155/icons/monochrome_large.png"
//     lrg_variant_image_url: "https://assets.ifttt.com/images/channels/603756155/icons/on_color_large.png"
//     module_name: "twitch"
//     name: "Twitch"
//     queries: (2) [{…}, {…}]
//     triggers: (8) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
//   }
// }
const mapTandas = (channel, type, tanda) => ({
  ...tanda,
  channel_name: channel.name,
  channel_module_name: channel.module_name,
  [`${type}_fields`]: tanda[`${type}_fields`].map(tandaField => ({
    ...tandaField,
    stored_field: formatStoredField(type, tanda.full_module_name, tandaField),
  })),
})

export function loadAvailableTandas(serviceModuleNames) {
  return graphQueryBang(AvailableTandasQuery, {
    serviceModuleNames,
  }).then(data =>
    data.channels.reduce(
      (acc, channel) => ({
        ...acc,
        [channel.module_name]: {
          ...channel,
          actions: channel.actions.map(mapTandas.bind(null, channel, "action")),
          queries: channel.queries.map(mapTandas.bind(null, channel, "query")),
          triggers: channel.triggers.map(
            mapTandas.bind(null, channel, "trigger")
          ),
        },
      }),
      {}
    )
  )
}

export function loadAvailableTandasUnified(serviceModuleNames) {
  return graphQueryBang(AvailableTandasQuery, {
    serviceModuleNames,
  }).then(data =>
    data.channels.reduce(
      (acc, channel) => ({
        ...acc,
        actions: [
          ...(acc.actions || []),
          ...channel.actions.map(mapTandas.bind(null, channel, "action")),
        ],
        queries: [
          ...(acc.queries || []),
          ...channel.queries.map(mapTandas.bind(null, channel, "query")),
        ],
        triggers: [
          ...(acc.triggers || []),
          ...channel.triggers.map(mapTandas.bind(null, channel, "trigger")),
        ],
        [channel.module_name]: channel,
      }),
      {}
    )
  )
}
